import { createSelector } from 'reselect';

import { selectSelectedCartItems } from './selectSelectedCartItems';

export const selectSelectedItemsCount = createSelector(
    [selectSelectedCartItems],
    (items) => items.reduce((acc, item) => acc + item.quantity, 0),
);
